// extracted by css-extract-rspack-plugin
export default {"footerContainer":"SpaceDialogFooter-module__footerContainer__RmnsPqs"};